import React from "react";
import { LOGOS } from "@/data/site";

/**
 * Brand mark wrapper, uses the real Consilium Pro logo (transparent PNG)
 * so brand colors (navy C, gold P, workforce silhouettes) are preserved.
 *
 * Rendered without a rectangular padded container so it reads as part of the
 * chrome, not a "sticker" pasted on top:
 *
 *   • variant="light", used on light/white backgrounds. Logo sits directly.
 *   • variant="dark" , used on dark navy backgrounds. Adds a soft ivory
 *                        circular "brand seal" backdrop (deliberate design
 *                        element, echoes the C's circular geometry) so the
 *                        navy C is legible without looking like a floating
 *                        white square.
 */
export default function CPMark({ className = "w-12 h-12", variant = "light" }) {
  if (variant === "dark") {
    return (
      <span className={`inline-flex items-center justify-center rounded-full bg-[#F4EFE4] shadow-[0_0_0_1px_rgba(201,162,39,0.35)] ${className}`}>
        <img src={LOGOS.mark} alt="Consilium Pro" className="w-[90%] h-[90%] object-contain" />
      </span>
    );
  }
  return <img src={LOGOS.mark} alt="Consilium Pro" className={`${className} object-contain`} />;
}
